var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSyringe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33CCCC"
    },
    d: "M331.803,313.711c-2.815,0-5.63-1.074-7.778-3.222L199.817,186.282   c-4.295-4.296-4.295-11.261,0-15.557c4.296-4.296,11.261-4.296,15.557,0l124.207,124.207c4.295,4.296,4.295,11.261,0,15.557   C337.433,312.637,334.618,313.711,331.803,313.711z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M508.778,101.201L411.596,4.018c-4.297-4.296-11.261-4.295-15.557,0c-4.295,4.296-4.295,11.261,0,15.557l15.848,15.848   l-78.544,78.545l-78.465-78.465c-4.296-4.296-11.261-4.296-15.557,0c-4.295,4.296-4.295,11.261,0,15.557l38.907,38.907   L66.151,302.043c-2.062,2.063-3.222,4.861-3.222,7.778s1.159,5.715,3.222,7.778l27.271,27.271l-36.831,36.83   c-2.062,2.063-3.222,4.861-3.222,7.778s1.159,5.715,3.222,7.778l20.898,20.898L3.222,492.425c-4.295,4.296-4.295,11.261,0,15.557   c2.148,2.148,4.963,3.222,7.778,3.222s5.63-1.074,7.778-3.222l74.269-74.269l21.695,21.695c2.148,2.148,4.963,3.222,7.778,3.222   s5.63-1.074,7.778-3.222l36.83-36.831l25.678,25.678c4.296,4.296,11.261,4.296,15.557,0l212.077-212.077l39.253,39.253   c2.148,2.148,4.963,3.222,7.778,3.222s5.63-1.074,7.778-3.222c4.295-4.296,4.295-11.261,0-15.557l-78.811-78.811l78.545-78.545   l18.238,18.238c2.148,2.148,4.963,3.222,7.778,3.222c2.815,0,5.63-1.074,7.778-3.222   C513.074,112.462,513.074,105.497,508.778,101.201z M122.521,432.073l-42.594-42.594l29.052-29.052l42.594,42.594L122.521,432.073z    M404.884,216.622L200.585,420.921l-111.1-111.1l29.527-29.527l22.295,22.295c2.148,2.148,4.963,3.222,7.778,3.222   s5.63-1.074,7.778-3.222c4.295-4.296,4.295-11.261,0-15.557l-22.295-22.295l29.966-29.966l22.295,22.295   c2.148,2.148,4.963,3.222,7.778,3.222s5.63-1.074,7.778-3.222c4.295-4.296,4.295-11.261,0-15.557l-22.295-22.295l67.454-67.454   l22.295,22.295c2.148,2.148,4.963,3.222,7.778,3.222s5.63-1.074,7.778-3.222c4.295-4.296,4.295-11.261,0-15.557l-22.295-22.295   l30.683-30.683L404.884,216.622z M380.883,161.508l-31.983-31.983l78.544-78.545l31.983,31.984L380.883,161.508z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyringe);
export default __webpack_public_path__ + "static/media/syringe.6315b64d2fdfee898f67568a6dd6a111.svg";
export { ForwardRef as ReactComponent };